module.exports = __webpack_public_path__ + "static/media/popup-docked-screenshot.accac529.jpg";